import React from "react";
import Provider from "../provider"
import useFormattedPrice from "@/hooks/shopify-hooks/useFormattedPrice";
import useCartSalePrice from "@/hooks/shopify-hooks/usecartSalePrice";

function PriceCmp(props = {}) {
	const { priceChange, variant } = props;
	const { cost, discountAllocations, merchandise, quantity } = variant;
	
	// 确保所有 Hooks 按固定顺序调用
	const _price = useFormattedPrice({
		price: cost.totalAmount,
		currencyCode: cost.totalAmount.currencyCode,
	});
	
	const initPrice = {
        amount: '0',
		currencyCode: cost.totalAmount.currencyCode,
    };
	
	// 始终调用 useFormattedPrice，但根据条件决定是否使用返回值
	const compareAtPrice = merchandise.compareAtPrice || initPrice;
	const salePriceRaw = useFormattedPrice({
		price: compareAtPrice,
		currencyCode: initPrice.currencyCode,
		quantity
	});
	
	// 始终调用 useCartSalePrice
	const discount = useCartSalePrice(merchandise.price, compareAtPrice, quantity, discountAllocations);
	
	// 在条件语句中处理值，而不是条件性地调用 Hooks
	const salePrice = (!merchandise.compareAtPrice || 
	                 merchandise.compareAtPrice.amount === '0' || 
	                 merchandise.compareAtPrice.amount === '0.00') ? 
	                 null : salePriceRaw;
	
	priceChange({
		salePrice,
		price: _price,
		discount,
	});

	return (<> </>)
}

export function reactPriceCmp(props) {
	return (<Provider><PriceCmp {...props}/></Provider>);
}

export default reactPriceCmp;